import { Component, OnInit, OnChanges, DoCheck, AfterViewChecked } from '@angular/core';

@Component({
  selector: 'app-support',
  templateUrl: './support.component.html',
  styleUrls: ['./support.component.less']
})
export class SupportComponent implements OnInit {

  constructor() { }

  ngOnInit() {
    $(window).resize(() => {
      this.changeSizeIframeContainer()
    });
    this.changeSizeIframeContainer()
  }

  changeSizeIframeContainer() {
    var headerDamage = $(".top-nav").height();
    var footerValidate = $(".tchekFooter").height()
    var totalHeight = $(window).height();
    $("#iframeContainer").height(totalHeight - headerDamage - footerValidate - 50);
  }
}




// WEBPACK FOOTER //
// ./src/app/support/support.component.ts